import React, { Component } from 'react';
import Root from "./components/Root";

class App extends Component {

	render() {
		return <Root />;
	}
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js